import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormSwitchInput from '../general-input-form/FormSwitchInput'
import FormDatePicker from '../general-input-form/FormDatePicker'
import FormSelectInput from '../general-input-form/FormSelectInput'

const AppForm = ({
  values,
  handleChange,
  errors,
  handleSwitch,
  onDateChange,
  gameOptions,
  handleSelectGame
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='gamevoucher_voucher_code'
          name='gamevoucher_voucher_code'
          colSize='6'
          inputLabel='Voucher Code'
          className='mb-3'
          placeholder='Enter voucher code...'
          value={values.gamevoucher_voucher_code}
          handleTextInput={handleChange}
          feedbackInvalid={errors?.gamevoucher_voucher_code}
          invalid={errors?.gamevoucher_voucher_code}
        />
        <FormDatePicker 
          id='gamevoucher_expired_date'
          name='gamevoucher_expired_date'
          colSize='3'
          inputLabel='Expired Date'
          className='mb-3'
          handleOnDateChange={(e) => onDateChange(e, 'gamevoucher_expired_date')}
          value={values.gamevoucher_expired_date}
          feedbackInvalid={errors?.gamevoucher_expired_date}
          invalid={errors?.gamevoucher_expired_date}
          disabled={errors?.gamevoucher_expired_date}
          minDate={new Date()}
        />
        <FormSwitchInput 
          id='gamevoucher_is_used'
          name='gamevoucher_is_used'
          colSize='3'
          inputLabel='Used?'
          className='mb-3'
          handleSwitch={(e) => handleSwitch(e, 'gamevoucher_is_used')}
          value={values.gamevoucher_is_used}
          invalid={errors?.gamevoucher_is_used}
        />
        <FormSelectInput 
          id='gamevoucher_game_value'
          name='gamevoucher_game_value'
          colSize='6'
          inputLabel='Game Name'
          selectOptions={gameOptions}
          value={values.gamevoucher_game_value}
          handleSelectInput={handleSelectGame}
          feedbackInvalid={errors.gamevoucher_game_value || errors.gamevoucher_game_value?.name}
          invalid={errors.gamevoucher_game_value || errors.gamevoucher_game_value?.name}
          disabled={false}
        />
      </CRow>
    </>
  )
}

export default AppForm